import React from "react";
import { useOutletContext } from "react-router-dom";
import SideBar from "./SideBar";
import PropTypes from "prop-types";

export default function Layout({ children }) {
  // Get menu state from Header via Outlet context
  const [menuOpen, setMenuOpen] = useOutletContext() || [false, () => {}];

  return (
    <>
      <div className="bg-mainBg w-full pt-4 xl:pt-0">
        {/* Overlay for mobile menu */}
        {menuOpen && (
          <div
            className="xl:hidden fixed inset-0 bg-black/50 z-[998] transition-opacity duration-300"
            onClick={() => setMenuOpen(false)}
            aria-hidden="true"
          />
        )}

        <div className="sm:max-w-[1200px] md:max-w-[1200px] lg:max-w-[1200px] xl:max-w-[1200px] relative w-full h-full m-auto xl:pt-7 pb-16 px-4 md:px-4 sm:px-14">
          <div className="grid grid-cols-12 gap-4">
            <div className="xl:mb-8 xl:col-span-3 col-span-12">
              <SideBar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
            </div>
            {children}
          </div>
        </div>
      </div>
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};
